import { render } from "./ScholarshipView.vue?vue&type=template&id=268b2a9a&scoped=true"
import script from "./ScholarshipView.vue?vue&type=script&lang=js"
export * from "./ScholarshipView.vue?vue&type=script&lang=js"

import "./ScholarshipView.vue?vue&type=style&index=0&id=268b2a9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-268b2a9a"]])

export default __exports__